import { encodeImageFileAsURL } from "utils/fileToBase64";
import { imageModalReducerActions, useImageModalContext } from "contexts/imageModal";

export const ImageUploadv2 = ({
	fileInputRef,
	setValue,
	name,
	watch = () => {},
	disableImgGallery = false,
	labelText = "Click to upload",
	marginClass = false,
}) => {
	const { dispatch: imageModalDispatch } = useImageModalContext();
	const filePath = watch(name);
	return (
		<div>
			<input
				type="file"
				className="form-control d-none"
				onChange={async (e) => {
					if (fileInputRef.current.files.length) {
						setValue(name, await encodeImageFileAsURL(fileInputRef.current.files[0]));
						e.target.value = "";
					}
				}}
				accept="image/*, application/pdf"
				ref={fileInputRef}
			/>
			<div className={marginClass ? marginClass : "mt-2"}>
				<small
					className="border border-light rounded px-3 py-2 text-light"
					style={{ cursor: "pointer" }}
					onClick={() => fileInputRef.current?.click()}
				>
					{labelText}
				</small>
			</div>

			{!disableImgGallery && (
				<div className="row mt-3">
					<div className="col-8">
						<img
							src={filePath}
							className={`img-fluid rounded ${!filePath && "d-none"}`}
							onClick={() =>
								imageModalDispatch({
									type: imageModalReducerActions.SHOW,
									payload: watch(name),
								})
							}
							alt="Uploaded"
						/>
					</div>
				</div>
			)}
		</div>
	);
};
